/**
 * Entra ID (Azure AD) configuration for server-side Web redirect flow.
 * Environment variables are injected by Vite at build time.
 */

const TENANT_ID = import.meta.env.VITE_ENTRA_TENANT_ID || '';
const CLIENT_ID = import.meta.env.VITE_ENTRA_CLIENT_ID || '';
const REDIRECT_URI =
  import.meta.env.VITE_ENTRA_REDIRECT_URI || window.location.origin + '/auth/callback';

/**
 * Builds the Entra ID authorize URL for the OAuth2 authorization code flow.
 */
export function getAuthorizeUrl(): string {
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    response_type: 'code',
    redirect_uri: REDIRECT_URI,
    scope: 'openid email profile User.Read',
    response_mode: 'query',
  });
  return `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/authorize?${params}`;
}

/**
 * Session duration for internal users: 8 hours in milliseconds.
 */
export const SESSION_MAX_DURATION_MS = 8 * 60 * 60 * 1000;
